import React from 'react';

import { Icon } from '@chakra-ui/react';

export const SecurityIcon = props => (
  <Icon viewBox="0 0 48 48" color="inherit" h="full" w="full" {...props}>
    <path
      className="a"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22.2,4.86,6.69,11.25V27C6.69,35.44,24,43.5,24,43.5S41.31,35.44,41.31,27V11.25L25.8,4.86A4.68,4.68,0,0,0,22.2,4.86Z"
    />
    <polygon
      className="a"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="30.45 20.7 24 20.7 24 11.78 17.69 25 24.14 25 24.14 33.92 30.45 20.7"
    />
  </Icon>
);
